import { API } from '../config';

export const createCategory = (userId, token, category) => {
    console.log(JSON.stringify(category));
    return fetch(`${API}/category/create/${userId}`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },

        body: JSON.stringify(category)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
            console.log(err);
        });
};

export const getAllOrders = (userId, token) => {
    return fetch(`${API}/get-all-orders/${userId}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};

export const updateOrderStatus = (userId, orderId, token, newOrderStatus) => {
    return fetch(`${API}/update-order-status/${userId}/${orderId}`, {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({status:newOrderStatus})
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};
